const columns = [
  {
    field: "tmpId",
    type: "tmpId",
    sort: "asc",
    width: 150,
  },
  {
    field: 'daysCount',
    label: 'Ilość nocy',
    sort: 'asc',
    width: 150,
  },
  {
    field: 'discount',
    label: 'Rabat',
    sort: 'desc',
    type: "custom",
    custom: function (column, row, navigate) {
      return row.discount + '%';
    },
    width: 80,
  },
];

export default columns;
